import React, { useState } from 'react';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    details: '',
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    if (!formData.name || !formData.email || !formData.mobile || !formData.details) {
      setStatus({ type: 'error', message: 'Please fill in all fields.' });
      setIsSubmitting(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setStatus({ type: 'error', message: 'Please enter a valid email address.' });
      setIsSubmitting(false);
      return;
    }

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setStatus({
        type: 'success',
        message: 'Thank you! Your message has been sent successfully.',
      });
      setFormData({ name: '', email: '', mobile: '', details: '' });
    } catch {
      setStatus({
        type: 'error',
        message: 'Failed to send message. Please try again later.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page">
      <header className="page-header">
        <span className="page-eyebrow">Get In Touch</span>
        <h1 className="page-title">Contact Us</h1>
        <p className="page-subtitle">
          Share your project requirements and our team will get back to you with a tailored prefab solution.
        </p>
      </header>

      <div className="contact-container">
        <div className="contact-form">
          <h2>Send us a Message</h2>

          {status.message && (
            <div className={`${status.type}-message`}>{status.message}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your full name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@company.com"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="mobile">Mobile Number *</label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="+91 XXXXX XXXXX"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="details">Project Details *</label>
              <textarea
                id="details"
                name="details"
                value={formData.details}
                onChange={handleChange}
                placeholder="Describe your porta cabin, site office, ceiling, or prefab requirements..."
                required
              />
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>

        <div className="contact-info">
          <h2>Reach Us Directly</h2>

          <div className="info-item">
            <span className="info-icon">📍</span>
            <div>
              <h4>Address</h4>
              <p>7, Jai Bhawani Market Atta, Sec 27</p>
              <p>Noida 201301, India</p>
            </div>
          </div>

          <div className="info-item">
            <span className="info-icon">📧</span>
            <div>
              <h4>Email</h4>
              <p>contact@adhunikprefabsystem.com</p>
            </div>
          </div>

          <div className="info-item">
            <span className="info-icon">📱</span>
            <div>
              <h4>Phone</h4>
              <p>+91 98105 58596</p>
            </div>
          </div>

          <div className="info-item">
            <span className="info-icon">🕒</span>
            <div>
              <h4>Business Hours</h4>
              <p>Monday – Friday: 9:00 AM – 6:00 PM</p>
              <p>Saturday – Sunday: Closed</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
